module.exports = __webpack_public_path__ + "static/fonts/Roboto-Regular.73f0a88.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/views/sales/dashboard3/assest/font/roboto/Roboto-Regular.woff2
// module id = PqHq
// module chunks = 0